import { useEffect } from 'react';

import { DialogContentText } from '@mui/material';
import axios, { AxiosError, AxiosHeaders, InternalAxiosRequestConfig } from 'axios';

import { AppDialog } from 'components/Dialogs';
import strings, { url } from 'constants/index';

export const FixtureCompetitorCollisionDialog = ({ isOpen, onHide, message, onClick }) => {
  useEffect(() => {
    const reqInterceptor = axios.interceptors.request.use(
      async (config: InternalAxiosRequestConfig) => {
        const resultConfig = config;
        if (
          ((config.method === 'post' || config.method === 'put' || config.method === 'patch') &&
            config.url === url.fixtures) ||
          (config.method === 'post' && config.url === `${url.fixtures}/recreate`) ||
          (config.method === 'post' &&
            config.url.startsWith(url.source_request) &&
            (config.url.endsWith('/approve') ||
              config.url.endsWith('/approve/edit') ||
              config.url.endsWith('/approve/recreate')))
        ) {
          const headers = AxiosHeaders.from(resultConfig.headers);
          headers.set('geniussports-skip-same-competitor-collision-rule', '1');
          resultConfig.headers = headers;
        }

        return resultConfig;
      },
      (error: AxiosError) => Promise.reject(error),
    );

    return () => axios.interceptors.request.eject(reqInterceptor);
  }, []);

  return (
    <AppDialog
      open={isOpen}
      title={strings.warning}
      onClose={onHide}
      confirmButton={{
        label: strings.yes,
        props: {
          onClick: async props => {
            await onClick(props);
            onHide();
          },
        },
      }}
    >
      <DialogContentText>{message}</DialogContentText>
    </AppDialog>
  );
};
